"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var COLOURS = {
  mono: {
    black: "#000",
    black10: "rgba(0, 0, 0, 0.1)",
    black25: "rgba(0, 0, 0, 0.25)",
    black50: "rgba(0, 0, 0, 0.5)",
    black75: "rgba(0, 0, 0, 0.75)",
    white: "#fff",
    white25: "rgba(255,255,255,0.25)",
    white50: "rgba(255,255,255,0.50)",
    white75: "rgba(255,255,255,0.75)",
    offwhite35: "rgba(220, 220, 240, 0.35)",
    offwhite15: "rgba(249, 249, 251, 0.15)",
    ghostWhite: "#F2F3F8"
  },
  cyan: {
    turquoise: "#2BD0B3",
    aqua: "#2ACFB3",
    aquaDark: "#469999",
    jungleGreen: {
      monkey: "#27BAA1",
      parrot: "#23A68F"
    }
  },
  grey: {
    codGrey: "#111111",
    nero: "#151515",
    coalMine: "#222222",
    mineShaft: "#262626",
    excavator: "#2D2D2D",
    nightRider: "#333333",
    tundora: "#474747",
    raspingSandy: "#555555",
    athens: {
      parthenon: "#F9F9FB",
      zeus: "#F5F6F8",
      bigFat: "#E8ECF0",
      smallSkinny: "#CBDFF2"
    },
    catSkillWhite: "#F2F4F8",
    mischka: {
      russian: "#D4D9E2",
      michael: "#CBD0DB"
    },
    dusty: "#979797",
    nevada: "#696D74",
    jumbo: "#7A7A7B",
    regent: "#8C96A9",
    regent50: "rgba(140,150,169,0.5)"
  },
  red: {
    thunderBird: "#BE1C22",
    alizarinCrimson: "#DD1F26",
    redApple: "#BE1D22"
  },
  yellow: {
    goldenTainoi: "#FFC850",
    dandelion: "#FFDC64",
    goldenShiny: "#FFCE44"
  },
  green: {
    greenSnake: "#6abd45"
  },
  userComment: {
    cerulean: "#27BAA1",
    heartfeltVermillion: "#ff1100",
    unsafeOchre: "#F69F1F",
    snapMint: "#50ff03",
    shallowOrchid: "#F118F8",
    archetypal: "#0A84FF",
    horseDrawnPansy: "#A65AF2",
    gulliblePlatinum: "#cffaf6"
  },
  pink: {
    internalPink: "#FF3366"
  }
},
    FONT_SIZES = {
  micro: "10px",
  small: "12px",
  default: "15px",
  large: "20px"
},
    FONT_WEIGHTS = {
  regular: 400,
  medium: 500,
  bold: 600
},
    NUMERIC_MEDIA_SIZES = {
  small: 639,
  medium: 1023,
  large: 1600,
  xlarge: 2048
},
    MEDIA_SIZES = Object.keys(NUMERIC_MEDIA_SIZES).reduce(function (a, b) {
  return _objectSpread({}, a, (0, _defineProperty2["default"])({}, b, "".concat(NUMERIC_MEDIA_SIZES[b], "px")));
}, {}),
    NUMERIC_MEDIA_RANGES = {
  smallMin: 0,
  smallMax: NUMERIC_MEDIA_SIZES.small,
  mediumMin: NUMERIC_MEDIA_SIZES.small + 1,
  mediumMax: NUMERIC_MEDIA_SIZES.medium,
  largeMin: NUMERIC_MEDIA_SIZES.medium + 1,
  largeMax: NUMERIC_MEDIA_SIZES.large,
  xlargeMin: NUMERIC_MEDIA_SIZES.large + 1,
  xlargeMax: 9999999
},
    MEDIA_RANGES = Object.keys(NUMERIC_MEDIA_RANGES).reduce(function (a, b) {
  return _objectSpread({}, a, (0, _defineProperty2["default"])({}, b, "".concat(NUMERIC_MEDIA_RANGES[b]).concat(0 === NUMERIC_MEDIA_RANGES[b] ? "" : "px")));
}, {}),
    MEDIA_QUERIES = {
  small: "@media screen and (max-width: ".concat(MEDIA_SIZES.small, ")"),
  medium: "@media screen and (max-width: ".concat(MEDIA_SIZES.medium, ")"),
  mediumUp: "@media screen and (min-width: ".concat(MEDIA_RANGES.mediumMin, ")"),
  large: "@media screen and (max-width: ".concat(MEDIA_SIZES.large, ")"),
  largeUp: "@media screen and (min-width: ".concat(MEDIA_RANGES.largeMin, ")"),
  xlarge: "@media screen and (max-width: ".concat(MEDIA_SIZES.xlarge, ")")
},
    FLATTENED_COLOURS = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2["default"])(function a(b) {
  var c;
  return (c = []).concat.apply(c, (0, _toConsumableArray2["default"])(Object.keys(b).map(function (c) {
    return "object" === (0, _typeof2["default"])(b[c]) ? a(b[c]) : (0, _defineProperty2["default"])({}, c, b[c]);
  })));
}(COLOURS))));
module.exports = {
  COLOURS: COLOURS,
  FONT_SIZES: FONT_SIZES,
  FONT_WEIGHTS: FONT_WEIGHTS,
  MEDIA_SIZES: MEDIA_SIZES,
  NUMERIC_MEDIA_SIZES: NUMERIC_MEDIA_SIZES,
  MEDIA_QUERIES: MEDIA_QUERIES,
  MEDIA_RANGES: MEDIA_RANGES,
  FLATTENED_COLOURS: FLATTENED_COLOURS
};